<template>
    <div class="bg-gray-type-5 h-full w-screen">
       <div class="mb-3"> 
            <div v-if="loadingEvent" class="flex flex-col justify-center items-center my-2">
                <div class="flex items-center justify-center h-screen">
                    <div class="spinner"></div>
                </div>
            </div>
            <template v-else>
                <div class="pt-10 px-4 lg:px-40">
                    <div class="flex justify-between pb-10">
                        <p class="text-sm"><span class="text-gray-4">
                            <router-link
                            :to="{ name: 'dashboard.create-event'}" 
                            >Events > </router-link>  
                            <router-link
                            :to="{ name: 'dashboard.manage-event'}" 
                            >
                                My events > 
                            </router-link>
                           </span> Event detail</p>
                        <div class="flex"
                            @click="showEditModal = !showEditModal"
                        >
                        <button class="hidden rounded-lg lg:flex item-center text-sm p-2 text-white bg-[#4848ED]">
                            <img class="mr-2" src="@/assets/icons/mod.svg">
                            Modify event  
                        </button>
                        <img class="cursor-pointer ml-3" src="@/assets/icons/more.svg">
                        </div>
                    </div>
                    <div>
                        <img class="w-full imageDimensions"  v-if="eventDetails.banner == 'null'" src="@/assets/icons/image-placeholder.svg" alt="">
                        <img v-else class="w-full imageDimensions" :src="eventDetails.banner">
                    </div>
                    <div class="mt-2">
                        <p v-if="eventDetails.status == 'accepted'" class="text-sm text-active bg-[#c9f3dd] w-[9rem] rounded-lg py-1 px-2 lg:hidden">Request accepted</p>
                        <p v-if="eventDetails.status == 'pending'" class="text-sm text-[#E7C805] bg-[#fcf7db] w-[9rem] rounded-lg py-1 px-2 lg:hidden">Request pending</p>
                        <p v-if="eventDetails.status == 'queried'" class="text-sm text-gray-4 bg-[#d4d1d1da] w-[9rem] rounded-lg py-1 px-2 lg:hidden">Request queried</p>
                    </div>
                </div>
               <div class="flex flex-col lg:flex-row justify-between px-5 lg:px-40 mt-12">
                    <div class="flex flex-col lg:w-[30.563rem]">
                        <div>
                            <h2 class="text-base lg:text-3xl font-bold pb-4">{{eventDetails.title}}</h2>
                            <p class="font-normal text-sm lg:text-xl text-gray-4">{{eventDetails.description}}</p>
                        </div>
                        <div class="mt-9">
                            <h5 class="text-base lg:text-3xl font-bold">Things to consider</h5>
                            <ul class="w-3/4 lg:w-full pl-5 list-disc">
                                <li class="text-sm lg:text-xl text-gray-4">You will be in charge of covering all your trip charges</li>
                                <li class="text-sm lg:text-xl text-gray-4">You can decide to book a return trip if your organizer did not cater for that</li>
                            </ul>
                        </div>
                    </div>
                    <div class="flex flex-col justify-between w-full lg:w-[32.756rem] bg-white rounded-lg p-6">
                        <div class="flex justify-between items-center py-3 under">
                            <h6 class="text-xs lg:text-sm text-gray-5">WAITLIST COUNT</h6>  
                            <p class="blu-pill font-bold text-xs lg:text-sm">{{totalRecords}} attendees</p>
                        </div>
                        <div class="flex justify-between items-center py-3 under">
                            <h6 class="text-xs lg:text-sm text-gray-5">REQUEST STATUS</h6> 
                            <p v-if="eventDetails.status == 'pending'" class="text-xs lg:text-sm text-[#E7C805] font-medium">Request pending</p>
                            <p v-if="eventDetails.status == 'accepted'" class="text-xs lg:text-sm text-active font-medium">Request accepted</p>
                            <p v-if="eventDetails.status == 'queried'" class="text-xs lg:text-sm text-gray-4 font-medium">Request queried</p>
                        </div>
                        <div class="flex justify-between items-center py-3 under">
                            <h6 class="text-xs lg:text-sm text-gray-5">LOCATION</h6> 
                            <p class="text-xs text-right lg:text-sm font-medium w-full">{{eventDetails.location}}</p>
                        </div>
                        <div class="flex justify-between items-center py-3 under">
                            <h6 class="text-xs lg:text-sm text-gray-5">EVENT DATE</h6> 
                            <p class="text-xs lg:text-sm font-medium">{{eventDetails.tripDate}} - {{eventDetails.returnDate}}</p>
                        </div>
                        <div class="flex justify-between items-center py-3 under ">
                            <h6 class="text-xs lg:text-sm text-gray-5" >ESTIMATED NO. OF ATTENDEE</h6> 
                            <p class="text-xs lg:text-sm font-medium">{{eventDetails.attendeesEstimate}}</p>
                        </div>
                        <div class="flex justify-between items-center py-3 under">
                            <h6 class="text-xs lg:text-sm text-gray-5">WHO WILL BE PAYING?</h6> 
                            <p class="text-xs lg:text-sm font-medium">{{eventDetails.payment}}</p>
                        </div>
                        <div class="flex justify-between items-center py-3 under">
                            <h6 class="text-xs lg:text-sm text-gray-5">ONBOARDING LINK</h6> 
                            <p v-if="eventDetails.status == 'accepted'" @click="copyLink(eventDetails.id)" class="flex text-xs lg:text-sm font-medium">https://www.shuttlers.ng/join-event <img class="ml-1" src="@/assets/icons/link.svg"></p>
                        </div>
                    </div>
                </div>
            </template>    
       </div>
       <template v-if="!loadingEvent && eventDetails">
          <div class="py-3 bg-white attend-table">
            <div class="flex justify-between p-3 border-b border-[#EAECF0]">
                <div class="flex items-center">
                    <h3 class="font-bold ml-6">Attendee list</h3>
                    <div class="text-white blu-dot ml-2">{{totalRecords}}</div>
                </div>
                <div class="flex items-center">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16675 10.5417C1.51193 10.5417 1.79175 10.8215 1.79175 11.1667V12.8333C1.79175 12.9484 1.88502 13.0417 2.00008 13.0417H12.0001C12.1151 13.0417 12.2084 12.9484 12.2084 12.8333V11.1667C12.2084 10.8215 12.4882 10.5417 12.8334 10.5417C13.1786 10.5417 13.4584 10.8215 13.4584 11.1667V12.8333C13.4584 13.6387 12.8055 14.2917 12.0001 14.2917H2.00008C1.19467 14.2917 0.541748 13.6387 0.541748 12.8333V11.1667C0.541748 10.8215 0.82157 10.5417 1.16675 10.5417Z" fill="#000005"/>
                    <path d="M5.94837 0.125C5.51971 0.125 5.16214 0.452602 5.1247 0.879624C4.99667 2.34022 4.97409 3.80799 5.05706 5.27154C4.85124 5.28291 4.6455 5.29609 4.43985 5.31108L3.1986 5.40156C2.72002 5.43645 2.45248 5.97008 2.71086 6.37444C3.59589 7.75951 4.73628 8.96362 6.07123 9.92258L6.56851 10.2798C6.82643 10.4651 7.17382 10.4651 7.43174 10.2798L7.92902 9.92258C9.26398 8.96362 10.4044 7.75951 11.2894 6.37444C11.5478 5.97008 11.2802 5.43645 10.8017 5.40156L9.5604 5.31108C9.35475 5.29609 9.14901 5.28291 8.94319 5.27154C9.02616 3.80799 9.00358 2.34022 8.87554 0.87962C8.83811 0.4526 8.48054 0.125 8.05188 0.125H5.94837Z" fill="#000005"/>
                    </svg>
                    <p class="font-bold px-1">Export list</p>
                </div>
            </div>
            <AppTable
                :loading="loadingAttendees"
                :error-loading="errorLoading"
                :items="attendeesTable"
                :fields="headers"
                :extraOptions="{ serverSide: true, totalSize: filters.pageSize }"
                @pageChange="changePage"
                @sizeChange="showPageSize"
            ></AppTable>
            </div>
            <modal :show="showEditModal" modal-class="modify-modal">
                        <form v-if="modSuccess" class="bg-white rounded-lg p-8 w-full sm:w-[42.125rem]" @submit.prevent="modifyEvent" ref="form">
                            <div class="flex items-center justify-between text-left">
                                <h1 class="text-xl font-bold">Modify your event</h1>   
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                                class="cursor-pointer"
                                @click="showEditModal = !showEditModal"
                                >
                                <path d="M11 1L1 11M1 1L11 11" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div class="flex flex-col lg:flex-row justify-between py-2">
                                <div class="flex flex-col mb-2 lg:mb-0">
                                    <label class="text-xs text-gray-4 pb-1">Name of event</label>
                                    <input type="text" v-model="form.title" class="sm:w-[17.75rem] w-full h-12 border-solid border border-gray-type-9 rounded-lg px-3" :placeholder="eventDetails.title">
                                </div>
                                <div class="flex flex-col">
                                    <label class="text-xs text-gray-4 pb-1">Event type</label>
                                    <input type="text"  v-model="form.type" class="sm:w-[17.75rem] w-full h-12 border-solid border border-gray-type-9 rounded-lg px-3" :placeholder="eventDetails.type">
                                    
                                </div>
                            </div>
                            <div class="flex flex-col py-2">
                                <label class="text-xs text-gray-4 pb-1">Description</label> 
                                <mavon-editor style="z-index: 1; min-height: 8.813rem; box-shadow: none; border: 1px solid #E5E9F2" :toolbars="toolbars" :language="'en'" :ishljs="false" :subfield="false" v-model="form.description"/>   
                            </div>
                            <div class="flex flex-col lg:flex-row justify-between py-2">
                                <div class="flex flex-col mb-2 lg:mb-0">
                                    <label class="text-xs text-gray-4 pb-1">Location of event</label>
                                    <input type="text" v-model="form.location" class="sm:w-[17.75rem] w-full h-12 border-solid border border-gray-type-9 rounded-lg px-3">
                                </div>
                                <div class="flex flex-col">
                                    <label class="text-xs text-gray-4 pb-1">Date of event</label>
                                    <date-picker v-model="date" type="date" range placeholder="Select date range"></date-picker>  
                                </div>
                            </div>
                            <div class="flex flex-col lg:flex-row justify-between py-2 items-center">
                                <div class="flex flex-col">
                                    <label
                                    class="text-xs text-gray-4 pb-1">Estimated number of attendees</label>
                                    <input type="number" v-model="form.attendeesEstimate" class="sm:w-[17.75rem] w-[20.813rem] h-12 border-solid border border-gray-type-9 rounded-lg px-3" >
                                
                                </div>
                                <div class="set-aside w-full ml-2 mt-5">
                                    <label class="switch">
                                        <input type="checkbox" v-model="form.returnTrip" :checked="form.returnTrip">
                                        <span class="slider round"></span>
                                    </label>   
                                    <label class="pl-2 text-xs">Would you like us to take the attendees to and fro?</label>
                                </div>
                            </div>
                            <div class="py-2">
                                <label class="text-xs text-gray-4 pb-1">Event Banner</label>
                                <div v-if="imageUploaded">
                                    <div  class="flex" id="preview" v-if="showImage">
                                        <img class="imageDimensions mr-2" v-if="form.banner" :src="form.banner"/>
                                        <img src="@/assets/icons/close.svg" @click="showImage = !showImage">
                                    </div>
                                    <label class="custom-file-upload text-xs w-full py-6 rounded-lg text-center" v-else>
                                        Drag or drop SVG, PNG, JPG or GIF (max. 800x400px)<br/><span class="text-bg-green-700">Click to browse</span>
                                        <input type="file" accept="image/*" @change="onFileSelected">
                                    </label>
                                </div>
                                <div v-if="processing" class="flex flex-col justify-center items-center my-2">
                                        <spinner></spinner>
                                        <span class="pt-1">Uploading..</span>
                                    </div>
                                <div class="flex" id="preview" v-if="uploaded">
                                    <img class="imageDimensions mr-2" v-if="previewUrl" :src="previewUrl" />
                                    <img src="@/assets/icons/close.svg" @click="showImage = !showImage">
                                </div>
                            </div>
                            <div class="flex justify-center py-2">
                                <button
                                type="submit"
                                class="w-full inline-flex items-center justify-center p-2 text-black rounded-md bg-active"
                                >
                                {{ processing ? 'Loading...' : `Update request`}}
                                </button>
                            </div>
                        </form>

                        <div v-else modal-class="admin-feedback-modal">
                        <div class="relative px-6 py-3 pb-6 text-dark-type-4">
                            <div class="mt-1 flex items-center flex-col">
                                <div class="my-1">
                                <img src="@/assets/icons/refund-success.svg">
                                </div>
                                <div class="text-center">
                                    <h3 class="text-lg font-normal text-dark-type-3">Request modified</h3>
                                    <p class="text-base text-dark-type-4">
                                        Your event request have been modified successfully. 
                                    </p>
                                </div>
                            </div>    
                            <button 
                            class="block w-full h-12 py-4 mt-8 font-bold text-center text-black text-sm bg-active rounded"
                            @click="showEditModal = false"
                            >Dismiss</button>
                        </div>  
                    </div>         
            </modal> 
       </template>  
    </div>
</template>

<script>
import axios from "@/services/axios";
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import {mavonEditor} from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import Modal from '@/components/Modal.vue'
import AppTable from '@/components/AppTable.vue'
import Spinner from '@/components/Spinner.vue'

 export default {
    name: "ViewEvent",
    props:["eventId"],
    components:{
        Modal,
        DatePicker, 
        mavonEditor,   
        AppTable,   
        Spinner
    },
    watch: {
    'filters.pageSize'() {
      this.fetchAttendees();
    },
    'filter.pageNumber'(){
        this.fetchAttendees();
    }
    },
    data: () => {
        return {
            toolbars:{
                bold: true,
                italic: true,
                underline: true,
                undo: true,
                redo: true,
                ol: true,
                alignleft: true,
                aligncenter: true,
            },
            form:{ },
            date:[],
            showEditModal: false,
            showImage: true,
            modSuccess: true,
            eventDetails: null,
            attendeesTable: null,
            loadingEvent: false,
            loadingAttendees: false,
            errorLoading: false,
            totalRecords: null,
            processing: false,
            previewUrl: null,
            uploaded: false,
            imageUploaded: true,
            tripDate: null,
            headers: [
                { label: 'ATTENDEE NAME', key: 'firstName' },
                { label: 'EMAIL ADDRESS', key: 'email' },
                { label: 'PHONE NUMBER', key: 'phone' },
                { label: 'NEAREST BUS STOP', key: 'pickupLocation' }
            ] ,
            filters: {
                count: 1,
                currentPage: 1,
                pageCount: 1,
                pageSize: 10,
                pageNumber: 1
            }, 
        }
    },
    methods:{
        async onFileSelected(e){
            this.showImage = false
            const s3ImageUrl =  await this.uploadTos3andGetDocumentUrl(e.target.files[0]);
            this.form.image_url = s3ImageUrl
            this.previewUrl = URL.createObjectURL(e.target.files[0]);  
        },
        async uploadTos3andGetDocumentUrl(file) {
            this.showImage = false
            this.processing = true 
            this.imageUploaded = false
            try {
                const formData = new FormData();
                    formData.append('file', file);
                    const response = await axios.post(
                    `/upload/identity/files`,
                    formData
                    );
                    if (response.data?.files?.length) {
                    return response.data.files[0].Location;
                    }
            } catch (error) {
                console.log(error)
                    this.$toast.warning(
                    'An error occured while uploading your file, please try again'
                    );
                } finally {
                this.processing = false
                this.uploaded = true
                console.log('uploading');
            }
            
        },
         async modifyEvent(){
            this.processing = true
            this.modSuccess = false
            try{
                await axios.patch(`https://api.test.shuttlers.africa/event/events/${this.eventId}`,{
                    "title": `${this.form.title}`,
                    "type": `${this.form.type}`,
                    "description": `${this.form.description}`,
                    "location": `${this.form.location}`,
                    "tripDate": `${this.date[0]}`,
                    "returnDate": `${this.date[1]}`,
                    "attendeesEstimate": parseInt(this.form.attendeesEstimate),
                    "banner": `${this.form.image_url}`,
                    "returnTrip": this.form.returnTrip,    
                })
            }
            catch(err){
                console.log(err)
            }
            finally {this.processing = false}
            
        },
         async fetchEvent(){
            this.loadingEvent = true
            try{
                let res = await axios.get(`https://api.test.shuttlers.africa/event/admin/events/${this.eventId}`)
                    if(res.status == 200){
                        let r = res.data.data 
                        let event = new Date(r.tripDate)
                        r.tripDate = event.toDateString()
                        r.returnDate = event.toDateString()
                        this.eventDetails = r
                        this.form = {...r}
                        this.date.push(new Date(r.tripDate) ,new Date(r.returnDate))
                    }       
            } catch(err){
                console.log(err)
            }
            finally{this.loadingEvent = false}
        },
        async fetchAttendees(){
             this.loadingAttendees = true;
            
            try {
                let res = await axios.get(`https://api.test.shuttlers.africa/event/${this.eventId}/attendee?page=${this.filters.pageNumber}&size=${this.filters.pageSize}`)
                if(res.status == 200){
                    let r = res.data.data
                    r.forEach((item) => {
                        item.firstName = item.firstName +' '+ item.lastName
                    })
                    this.attendeesTable = r
                }
                this.totalRecords = res.data.metadata.pageSize;
            } 
            catch(err){
                console.log(err)
            }
            finally{this.loadingAttendees = false;}
        },
        changePage(pageCount) {
             this.filters.pageCount = pageCount;
        },
        showPageSize(pageSize) {
            this.filters.pageSize = pageSize;
        },
        copyLink(id){
            let baseText = "https://test.shuttlers.africa/join-event";
            navigator.clipboard.writeText(`${baseText}/${id}`);
            this.$toast.success(
                        `Link copied, ${baseText}/${id}`
            );      
        }
    },
    created(){
        this.fetchEvent()
        this.fetchAttendees()
    }
}

</script>


<style lang="scss">

.blu-pill{
    padding: 4px 12px;
    background: #E5E5FE;
    border-radius: 16px;
    color: #4848ED;
}
.blu-dot{
    background: #4848ED;
    border-radius: 16px;
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    width: 40px;
    height: 22px;
  
}
.under{
    border-bottom: 0.4px dashed #E5E9F2;
}
.attend-table{
    border: 1px solid #EAECF0;
    width: 1124px;
    margin: 25px auto;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
    border-radius: 8px;
}


@import '@/assets/css/switch';

.set-aside{
    display: grid;
    grid-template-columns: auto auto;
}

.mx-datepicker .mx-input {
    border: 1px solid #E5E9F2;
    border-radius: 8px;
    height: 48px;
}

.custom-file-upload {
      border: 1px dashed #B9BCC8;
      display: inline-block;
      cursor: pointer;
    input{
        display: none;
    }
    span{
        color: #0DAC5C;
        border-bottom: 1px solid #0DAC5C;
    }
}

button:disabled {
    background:#E5E9F2;
    color:#EFF2F7;
}

.imageDimensions {
     width: 100%;
     height: 194px;
     border-radius: 8px;
     object-fit: cover;
}

@media only screen and (max-width: 425px){
    .imageDimensions {
        width: 335px;
        height: 145px;
        margin: 0 auto;
    }
    .attend-table{
        width: 100%;
    }
    .mx-input{
        width: 325px;
    }
    .mx-datepicker-range{
        width: 315px;
    }
}

@media only screen and (min-width: 1441px){
    .attend-table{
        width: 88%;
    }
}
</style>

<style>
.admin-feedback-modal {
  @apply sm:max-w-md;
}

@media only screen and (max-width: 425px){
    .modify-modal{
        width: 82%;
    }
}
</style>